import { notification } from 'antd'
import i18next from 'i18next'

import { getSharedKey } from '../i18n/getKeys'

const BYTE_IN_MEGABYTE = 1024 * 1024

export const filesValidate = (
  files: FileList,
  fileValidationOptions?: {
    maxFileSizeMb?: number
    allowedFileFormats?: string[]
  },
): boolean => {
  if (!fileValidationOptions) {
    return true
  }

  let flag = true

  if (files.length > 0) {
    for (const file of files) {
      const fileNameParts = file.name.split('.')
      const fileFormat = fileNameParts[fileNameParts.length - 1].toLowerCase()
      const fileSizeInMb = file.size / BYTE_IN_MEGABYTE

      if (fileValidationOptions.maxFileSizeMb && fileSizeInMb >= fileValidationOptions.maxFileSizeMb) {
        notification.error({
          message: i18next.t(getSharedKey('error')),
          description: i18next.t(getSharedKey('maxFileSizeErrorMessage'), {
            fileName: file.name,
            count: fileValidationOptions?.maxFileSizeMb,
          }),
        })

        flag = false
      }

      if (
        fileValidationOptions.allowedFileFormats &&
        !fileValidationOptions.allowedFileFormats.map((format) => format.toLowerCase()).includes(fileFormat)
      ) {
        notification.error({
          message: i18next.t(getSharedKey('error')),
          description: `${i18next.t(getSharedKey('allowedFileFormatsError'), {
            fileName: file.name,
            fileFormat: fileFormat,
          })} \n${i18next.t(getSharedKey('allowedFileFormats'), {
            allowedFileFormats: fileValidationOptions.allowedFileFormats,
          })}`,
        })

        flag = false
      }
    }

    return flag
  }

  return true
}
